import { GetPermitHistoryResponseBodyDTO } from '@ketch-com/figurehead'
import { APIRequestParams } from 'api/common/utils'
import { API } from 'utils/api/api'
import { formatRequestString } from 'utils/helpers/api/queryString'

type Params = APIRequestParams<{
  identifierCode: string
  identifierValue: string
  transactionID: string
  permitType: 'purpose' | 'subscription_topic'
}>

export const getOrInitiatePermitHistory = ({ identifierCode, identifierValue, transactionID, permitType }: Params) =>
  API.get<GetPermitHistoryResponseBodyDTO>(
    formatRequestString({
      entityUrl: `/api/permit-history/${identifierCode}/${identifierValue}`,
      params: {
        filters: {
          transactionID,
          permitType,
        },
      },
    }),
  )
